import kdsLogo from '../../../public/logo1.png';
import { Button } from '@klover/attain-design-system';
import { ERROR_BOUNDARY_MESSAGE, RETURN_TO_HOMEPAGE } from '../../content';
import { Routes } from 'constants/index';
import * as Styled from './index.styles';

const ErrorMsg = () => {
  return (
    <Styled.Wrapper>
      <Styled.Logo src={kdsLogo} alt="KDS" />
      <Styled.Message>{ERROR_BOUNDARY_MESSAGE}</Styled.Message>
      <a href={Routes.AUDIENCE_MANAGER}>
        <Button variant="contained">{RETURN_TO_HOMEPAGE}</Button>
      </a>
    </Styled.Wrapper>
  );
};

export default ErrorMsg;
